import React, { FC } from 'react';
import GenericModal from 'src/components/shared/generic-modal/generic-modal';
import { observer } from 'mobx-react-lite';

interface ApplyDraftsModalProps {
    visible: boolean;
    onClose: () => void;
    onConfirm: () => void;
    connectionCount: number;
    isLoading: boolean;
}

const ApplyDraftsModal: FC<ApplyDraftsModalProps> = observer(({ visible, onClose, onConfirm, connectionCount, isLoading }) => {

    return (
        <GenericModal
            open={visible}
            title="Apply Policy"
            body={
                <div>
                    <p>You are about to apply new security policies for {connectionCount} connection{connectionCount === 1 ? '' : 's'}.<br />
                        Once completed, you will be notified by email.</p>
                </div>
            }
            actionButtons={[
                {
                    text: 'Cancel',
                    onClick: onClose,
                    className: 'secondary-btn',
                },
                {
                    text: 'Apply',
                    onClick: onConfirm,
                    className: `primary-btn ${isLoading ? 'loading' : ''}`,
                }
            ]}
            onCancel={onClose}
        />
    );
});

export default ApplyDraftsModal;